<mat-card style="padding-bottom: 40px;">
  <mat-list role="list">
    <div mat-subheader>Archivos</div>
    <mat-list-item role="listitem" *ngFor="let file of fileUploads">
      <mat-icon mat-list-icon>description</mat-icon>
      <div mat-line>
        <span>
          <a target="_blank" [href]="file.url" >{{file.name}}</a>
          <span style="margin-left: 10px; font-size: 12px;" *ngIf="file.created">Created: {{file.created | date:'medium'}}</span>
        </span>
        <button *ngIf="canDelete" (click)="deleteFileUpload(file)" style="margin-left: 20px;" mat-button>Borrar</button>
      </div>
    </mat-list-item>
  </mat-list>
</mat-card>
